/* eslint-disable no-useless-escape */
/**
 *
 * @param {*樣板} templateString
 * @param {*變數} variables
 */
export const mergeVariables = function(templateString = '', variables = {}) {
  let regexp = /\$\{\w+\}/g;

  let shouldBeReplacedParameters = templateString.match(regexp) || [];

  for (let parameter of shouldBeReplacedParameters) {
    let refKey = parameter.replace(/(.*)?[$][{]([a-z0-9]+)[}](.*?)/gi, '$1$2$3');
    let value = variables[refKey] != null ? variables[refKey] : parameter;

    templateString = templateString.replace(parameter, value);
  }

  return templateString;
};

/**
 *
 * @param {*values.ref} kvPairValues
 */
export const arrangeData = function(kvPairValues = []) {
  let data = {};

  for (let kvPair of kvPairValues) {
    let key = kvPair.key;
    let value = kvPair.value;
    data[key] = value;
  }

  return data;
};

/**
 *
 * @param {*the list is from list.func.action.param} actionParameterList
 */
export const extractActionParameters = function(actionParameterList = [], data = {}) {
  let extractedParams = [];
  for (let param of actionParameterList) {
    let value = param.value;

    if (value) {
      //變數名稱為${ref}則回傳整個valeu.ref
      let regexp = /\$\{ref\}/g;

      let refParams = value.match(regexp) || [];
      if (refParams.length > 0) {
        extractedParams.push(data);
      } else {
        let mergedValue = mergeVariables(value, data);
        extractedParams.push(mergedValue);
      }
    }
  }

  return extractedParams;
};

/**
 * filter display data by position
 * @param {*display config} display
 */
export const filterDisplayDataByPosition = function(display = []) {
  return display.filter(function(config) {
    if (config.position >= 0) {
      return true;
    }

    return false;
  });
};

/**
 * filter display data by position and corresponding data
 * @param {*display config} display
 */
export const filterDisplayDataByPositionAndCorrData = function(display = [], data = {}) {
  return display.filter(function(config) {
    if (config.position >= 0 && data[config.field]) {
      return true;
    }

    return false;
  });
};

/** get display config by type */
export const getDisplayDataByType = function(display = [], typeName = '') {
  let seqIndex = display
    .map(function(display) {
      return display.type;
    })
    .indexOf(typeName);

  return display[seqIndex] || {};
};

/**
 *
 * @param {*display config} display
 */
export const sortDisplayDataByPosition = function(display = []) {
  return display.sort(function(obj1, obj2) {
    if (obj1.position < obj2.position) {
      return -1;
    }

    if (obj1.position > obj2.position) {
      return 1;
    }

    return 0;
  });
};

export const getObjectByKey = function(targetArray = [], key = '') {
  let value = '';

  if (!targetArray || !key) {
    return value;
  }

  let index = targetArray.map(paramKeyValue => paramKeyValue.key).indexOf(key);

  return targetArray[index] || {};
};

export const encodeJsonString = (jsonString = {}) => {
  return JSON.stringify(jsonString)
    .replace('searchInput', ',s1')
    .replace('searchField', ',s2')
    .replace('filterField', ',f1')
    .replace('filterValue', ',f2')
    .replace(/\":\[\"/gi, '1,') /* ":[" */
    .replace(/\"],\"/gi, '2,') /* "]," */
    .replace(/\":\"/gi, '3,') /* ":" */
    .replace(/\",\"/gi, '4,') /* "," */
    .replace(/\"/gi, '^')
    .replace(/]/gi, '@');
};

export const decodeString = encodeJsonString => {
  if (encodeJsonString == null) {
    return '';
  } else {
    return encodeJsonString
      .replace(',s1', 'searchInput')
      .replace(',s2', 'searchField')
      .replace(',f1', 'filterField')
      .replace(',f2', 'filterValue')
      .replace(new RegExp('1,', 'gm'), '":["')
      .replace(new RegExp('2,', 'gm'), '"],"')
      .replace(new RegExp('3,', 'gm'), '":"')
      .replace(new RegExp('4,', 'gm'), '","')
      .replace(/\^/gi, '"')
      .replace(/@/gi, ']');
  }
};

export default {
  mergeVariables,
  arrangeData,
  extractActionParameters,
  filterDisplayDataByPosition,
  filterDisplayDataByPositionAndCorrData,
  sortDisplayDataByPosition,
  getObjectByKey,
  encodeJsonString,
  decodeString
};
